<template>
    <div class="form-container bg-white">
        <div class="form-container-header">
            <div class="form-title">
                <div
                    class="form-title-title"
                    v-html="'Please enter your new password.'"></div>
            </div>
        </div>
        <form
            class="form-container-body"
            @submit.prevent='send'>
            <div class="form-container-body">
                <div class="form-row">
                    <div class="col-12 col-sm-12">
                        <div class="form-group">
                            <input
                                type="password"
                                ref="password"
                                v-model="password"
                                name="new_password"
                                v-validate='"required"'
                                :class="{'is-danger': errors.has('new_password') }"
                                class="form-control"
                                data-vv-name="password"
                                placeholder="New password"
                            >
                        </div>
                        <div class="form-group">
                            <input
                                type="password"
                                name="password_confirmation"
                                v-model="password_confirmation"
                                v-validate="'required|confirmed:password'"
                                :class="{'is-danger': errors.has('password_confirmation') }"
                                class="form-control"
                                data-vv-as="password"
                                placeholder="Repeat Password"
                            >
                        </div>
                    </div>
                    <transition name="fade" v-if="$store.state.loading">
                        <b-col md="12" class="d-flex justify-content-center mb-2">
                            <b-spinner class="align-middle text-info"></b-spinner>
                        </b-col>
                    </transition>
                </div>
            </div>
            <div class="form-container-footer pb-3">
                <button type="submit" class="btn btn-accent">Save</button>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        name: 'NewPassword',
        data() {
            return {
                password: '',
                password_confirmation: ''
            }
        },
        methods: {
            send() {
                let { token, username } = this.$route.query
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.$api('PATCH', this.$endpoints.forgotPassword.checkToken, null, {token, username}).then(response => {
                            this.$api('PATCH', this.$endpoints.forgotPassword.newPassword, {forgotPassword: this.password}).then(response => response)
                        })
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Authentication/NewPassword/NewPassword.vue